import { useEffect, useState, useRef } from "react"
import useWindowSize from "hooks/useWindowSize"

const Frame = ({ url, style={} }) => {
  const [width, setWidth] = useState(0)
  const elementRef = useRef(document.createElement("div"))
  const windowSize = useWindowSize()

  useEffect(() => {
    setWidth(elementRef.current.offsetWidth)
  }, [windowSize.width])

  let size = Math.floor(width)+"px"

  return (
    <div ref={elementRef}>
      <iframe title={url} width={size} height={size} frameBorder="0" scrolling="no" src={url} style={style}/>
    </div>
  )
}

export default Frame